import { optionSubcategory_messageContent } from './messageContentSubcategory.locstring.json';
import ConfettiOption from 'owa-confetti-option/lib/ConfettiOption';
import LinkPreviewOption from 'owa-link-preview-option/lib/LinkPreviewOption';
import MessageFormatOption from 'owa-message-format-option/lib/MessageFormatOption';
import QuickSuggestionsOption from 'owa-quick-suggestions-option/lib/QuickSuggestionsOption';
import ReplyOption from 'owa-reply-option/lib/ReplyOption';
import SignatureOption from 'owa-signature-option/lib/SignatureOption';
import UndoSendOption from 'owa-undo-send-option/lib/UndoSendOption';
import ComposeAssistanceOption from 'owa-compose-assistance/lib/ComposeAssistanceOption';
import { OptionSubCategory } from 'owa-options-core';
import { SuggestedRepliesOption } from 'owa-suggested-replies-option';
import initPbpSettings from 'owa-pbp-option-publishing-settings/lib/orchestration/initPbpSettings';

let messageContentSubcategory: OptionSubCategory = {
    key: 'messageContent',
    titleStringKey: optionSubcategory_messageContent,
    options: [
        SignatureOption,
        MessageFormatOption,
        ReplyOption,
        LinkPreviewOption,
        UndoSendOption,
        ConfettiOption,
        QuickSuggestionsOption,
        SuggestedRepliesOption,
        ComposeAssistanceOption,
    ],
    onSelected: initPbpSettings,
};

export default messageContentSubcategory;
